// @file Dark mode mixin
import { observeDarkMode } from 'bits/dark_mode'
import { Component, namespace, Vue } from 'bits/vue'
import debounce from 'lodash.debounce'

const browser = namespace('browser')

@Component({})
export default class extends Vue {
  unobserveDarkMode
  @browser.Action toggleDarkMode

  mounted(): void {
    this.unobserveDarkMode = observeDarkMode(debounce(this.toggleDarkMode, 100))
  }

  beforeDestroy(): void {
    this?.unobserveDarkMode()
  }
}
